<template>
  <form action="">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <img src="../assets/srvu-logo.png">
        <p class="modal-card-title">Login</p>
        <button
        type="button"
        class="delete"
        @click="$emit('close')"/>
      </header>
      <section class="modal-card-body">
        <b-field label="Email">
          <b-input
          type="email"
          v-model="email"
          placeholder="Your email"
          required>
        </b-input>
      </b-field>

      <b-field label="Password">
        <b-input
        type="password"
        v-model="password"
        password-reveal
        placeholder="Your password"
        required>
      </b-input>
    </b-field>

    <b-checkbox>Remember me</b-checkbox>
  </section>
  <footer class="modal-card-foot">
    <button class="button" type="button" @click="$emit('close')">Close</button>
    <button class="button" @click="login" is-primary :disabled="!email || !password">Login</button>
  </footer>
  </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      email: '',
      password: '',
    };
  },
  methods: {
    ...mapActions(['setToken']),
    async login() {
      window.event.preventDefault();

      try {
        const res = await this.$auth.post('/login', {
          email: this.email,
          password: this.password,
        });

        this.setToken(res.data.token);
        this.email = '';
        this.password = '';
        this.$emit('close');
        this.$router.push('Integrations');
      } catch (error) {
        this.$buefy.dialog.alert({
          title: 'Login Error',
          message: error.message,
          type: 'is-danger',
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Login.vue